import React, { useEffect, useState } from 'react';

import { StyledContainer } from './styles';
import { useQuery } from '../../Utils';
import firebase from '../../Firebase.js';
import Modal from 'react-modal';


const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(55, 55, 55, 0.7)',
  },
  content: {
    top: '20%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    zIndex: '20000',
    width: '400px',
    transform: 'translate(-50%, 0)',
    borderRadius: "15px",
    border: "0px",
    padding: "0px",
    background: '#f5f2e4',
    boxShadow: 'var(--default-drop-shadow)'
  }
};

export default function EmailVerify({
}) {
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [resent, setResent] = useState(false);

  const query = useQuery();
  const email = query.get("email");

  useEffect(() => {


    // Get the action to complete.
    // var mode = getParameterByName('mode');
    // Get the one-time code from the query parameter.
    // var actionCode = getParameterByName('oobCode');
    let actionCode = query.get("oobCode");
    // (Optional) Get the continue URL from the query parameter if available.
    // var continueUrl = getParameterByName('continueUrl');
    // (Optional) Get the language code if available.
    // var lang = getParameterByName('lang') || 'en';
    // Localize the UI to the selected language as determined by the lang
    // parameter.
    // Try to apply the email verification code.

    firebase.auth().applyActionCode(actionCode).then((resp) => {
      // Email address has been verified.

      // TODO: Display a confirmation message to the user.
      // You could also provide the user with a link back to the app.

      // TODO: If a continue URL is available, display a button which on
      // click redirects the user back to the app via continueUrl with
      // additional state determined from that URL's parameters.
      console.log("yay");
      setSuccess(true);
    }).catch((error) => {
      // Code is invalid or expired. Ask the user to verify their email address
      // again.
      setError(true);
      console.log(error);
    });
  }, []);


  return (
    <Modal
      isOpen={true}
      style={customStyles}
    >
      <StyledContainer>

        {!error && !success &&
          <h1>Verifying...</h1>
        }

        {success &&
          <h1>Successfully verified!</h1>
        }

        {error === "email-missing" &&
          <>
            <h1>This Sign in Link is Invalid</h1>
            <p>This can happen if the link was truncated or altered. Try going back to your email and clicking on the link again or <a href="/email-sign-in">try sending yourself a new link</a></p>
          </>
        }

        {error === "invalid" &&
          <>
            <h1>This Sign in Link has Expired</h1>
            <p>You may have already clicked on this link</p>
            {resent &&
              <p>We've sent a fresh link to the email {email}. Check your inbox to sign in.</p>
            }
            {!resent &&
              <p><a href="/app">Try sending yourself a new link</a></p>
            }
          </>
        }

        {error === "generic" &&
          <>
            <h1>Uh oh, looks like something went wrong.</h1>
            <p>Email us at <a href="mailto:hi@sudowrite.com">hi@sudowrite.com</a> for help.</p>
          </>
        }
      </StyledContainer>
    </Modal>
  );
}
